import { combineReducers } from "redux";
import navigationReducer from "utils/redux/reducer/navigation";
import resumeReducer from "utils/redux/reducer/resume";

const reducer = combineReducers({
  navigationReducer,
  resumeReducer,
});

export default reducer;
